import { useRef } from 'react';
import MaterialSymbol from '../../../DataDisplay/MaterialSymbol/MaterialSymbol';
import { withStyles } from '../../../../utils/utils';
import styles from './Chip.module.scss';

const cn = withStyles(styles);

export type ChipProps = {
  label: string;
  disabled?: boolean;
  onDelete?: () => void;
};

export default function Chip({ label, disabled, onDelete }: ChipProps) {
  const mouseDownRef = useRef(false);

  return (
    <div className={cn('chip')}>
      <span className={cn('chipLabel')}>{label}</span>
      {!disabled && onDelete && (
        <button
          type="button"
          className={cn('chipRemoveIcon')}
          onMouseDown={(e) => {
            mouseDownRef.current = true;
            e.preventDefault();
            e.stopPropagation();
          }}
          onMouseUp={(e) => {
            if (mouseDownRef.current) {
              e.preventDefault();
              e.stopPropagation();
              onDelete();
            }
            mouseDownRef.current = false;
          }}
          onKeyUp={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              e.stopPropagation();
              onDelete();
            }
          }}
        >
          <MaterialSymbol icon="close" size="16px" />
        </button>
      )}
    </div>
  );
}
